export enum Lang {
  ar , en, tr
}
